module.exports = __webpack_public_path__ + "static/media/SAT-logo.6962e723.svg";